// extracted by mini-css-extract-plugin
export default {"section":"Checkout__section-S8AL","component":"Checkout__component-wS_g","logoBuyer":"Checkout__logoBuyer-pO7B","buyerName":"Checkout__buyerName-aTRj"};